import React from 'react';

const AutoRepairPage = () => {
  return (
    <div>
      <h1>Auto Repair</h1>
    </div>
  );
};

export default AutoRepairPage;
